"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var propTypes = {
  type: _propTypes.default.string,
  children: _propTypes.default.object,
  setVisibility: _propTypes.default.func,
  getCursorPos: _propTypes.default.func
};

function Trigger(props) {
  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      styles = _useState2[0],
      setStyles = _useState2[1];

  var _props$children$props = props.children.props,
      setVisibility = _props$children$props.setVisibility,
      getCursorPos = _props$children$props.getCursorPos;
  var triggerContainerRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var childStyles = window.getComputedStyle(_reactDom.default.findDOMNode(triggerContainerRef.current.children[0]));
    setStyles({
      width: childStyles.getPropertyValue('width'),
      height: childStyles.getPropertyValue('height'),
      margin: childStyles.getPropertyValue('margin')
    });
  }, []);
  return _react.default.createElement("div", {
    onMouseOver: function onMouseOver() {
      return setVisibility(true);
    },
    onMouseOut: function onMouseOut() {
      return setVisibility(false);
    },
    onMouseMove: function onMouseMove(e) {
      return getCursorPos(e);
    },
    onTouchStart: function onTouchStart() {
      return setVisibility(true);
    },
    onTouchEnd: function onTouchEnd() {
      return setVisibility(false);
    },
    ref: triggerContainerRef,
    style: styles
  }, props.children.props.children);
}

Trigger.propTypes = propTypes;
var _default = Trigger;
exports.default = _default;
//# sourceMappingURL=Trigger.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-hover/dist/lib/Trigger.js
// module id = 1088
// module chunks = 0